module.exports = __webpack_public_path__ + "static/media/52574050_2452968941444949_2327038187488149504_o.bf919f75.jpg";